module.exports = __webpack_public_path__ + "static/img/visa.bf9d025.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/visa.png
// module id = Xwnd
// module chunks = 1